import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { loginUser,loginRegisterUser, loginTest } from '../store/actions/userAction'
import ContactForm from '../public/ContactForm'
import Navigation from '../public/NavbarHomepage'
import { Button, TextField, Link, Grid, Container } from '@material-ui/core';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import InputAdornment from '@material-ui/core/InputAdornment';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { withTranslation } from 'react-i18next'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { FaTimes } from "react-icons/fa";
import env from "../env"
const { QuickeySDK } = require('quickey-web-sdk')

const useStyles = makeStyles((theme) => ({
  containerNavbar: {
    [theme.breakpoints.down("sm")]: {
        background: '#191919', 
        padding: '0 25px'
    },
    [theme.breakpoints.up("sm")]: {
        background: '#191919', 
        padding: '0 64px'
    },
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  form: {
    width: '100%'
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: "rgb(26, 26, 26)",
    color: "white",
    borderRadius: "3px",
    textAlign: "center"
  },
  submitPopup: {
    width: "93%",
    margin: "auto",
    backgroundColor: "rgb(26, 26, 26)",
    color: "white",
    borderRadius: "3px",
    textAlign: "center"
  },
  containerTop: {
    [theme.breakpoints.down("sm")]: {
      marginTop: "-2rem",
      marginBottom: "-4rem",
    },
    [theme.breakpoints.up("sm")]: {
      marginTop: "0",
    },
  },
  divider: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    }
  },
  imageLogin: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    }
  },
  txtLogin: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: "22px",
      marginTop: "1.5rem"
    },
  },
  btnClosePopup: {
    width: "30px",
    height: "30px",
    padding: "0",
    borderRadius: "50%",
    minWidth: "unset",
    position: "absolute",
    top: "5px",
    right: "5px",
    color: "black"
  },
  btnResend: {
    position: "absolute",
    right: "1px",
    top: "14px",
    border: "1px solid grey",
    padding: "3px 10px",
    fontSize: "12px",
    color: "grey"
  },
  phoneNumber: {
    fontWeight: "bold",
    [theme.breakpoints.down("sm")]: {
      display: "block",
    }
  },
  dialogContentText : {
    fontWeight: "bold",
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
    }
  }
}));


const Login = ({ t }) => {
    const classes = useStyles();
    const [ input, setInput ] = useState({
      email: '',
      password: '',
      phone: '',
      otpCode: '',
      // email_redirect: '',
      // provider_redirect: ''
    })
    const history = useHistory()
    const dispatch = useDispatch()
    const appId = env.REACT_APP_QUICKEY_APP_ID
    const url = new URL(window.location.href);
    const email_redirect = url.searchParams.get("email");
    const provider_redirect = url.searchParams.get("provider");
    const quickey = new QuickeySDK('awM6rs9IKX0ZA4lrfco5eI1N30X_bqcKc-hSHqgYvsE')

    useEffect(async () => {
      if (email_redirect && provider_redirect) {
        handleEmailRedirectSubmit(email_redirect, provider_redirect)
      }  
    }, [email_redirect, provider_redirect])

    const handleEmailRedirectSubmit = async (email, provider) => {
        const response = await quickey.auth.getAccessToken({
          email: email,
          provider: provider
        })
        if (response.access_token) {
          dispatch(loginRegisterUser(response))
        } else {
          console.log(response);
        }
    }

    const [lang, setLang] = useState('')
    
    const setLocale = (locale) => {
      setLang(locale)
    }

    const [open, setOpen] = useState(false);

    const [values, setValues] = useState({
      password: '',
      showPassword: false,
    });

    const handleClickShowPassword = () => {
      setValues({ ...values, showPassword: !values.showPassword });
    };
  
    const handleMouseDownPassword = (event) => {
      event.preventDefault();
    };

    const handleChangePassword = (prop) => (e) => {
      setValues({ ...values, [prop]: e.target.value });
      let { name, value } = e.target
      setInput({ ...input, [name]: value })

    };

    const handleChangeCheck = (event) => {
      setState({ ...state, [event.target.name]: event.target.checked });
    };

    const [state, setState] = useState({
      checkedG: true,
    });

    const handleClickOpen = (provider) => {
      setOpen(true);
      handleOtpSubmit(provider)
    };

    const handleClose = () => {
      setOpen(false);
    };


    const handleChange = (e) => {
        let { name, value } = e.target
        setInput({ ...input, [name]: value })
    }

    const handleEmailSubmit = (e) => {
        e.preventDefault()
        if (input.email == 'admin' && input.password == 'pass') {
          dispatch(loginTest(input))
        } else {
          dispatch(loginUser(input))
        }
        history.push('/app')
    }

    const handleOtpSubmit = async (provider) => {
      const response = await quickey.provider.sendOTP({
          phone: input.phone,
          provider: provider
      })
    }

    const handleOtpConfirmation = async (e) => {
      e.preventDefault()
      const response = await quickey.auth.getAccessToken({
        phone: input.phone,
        provider: 'waOTP',
        otpCode: input.otpCode
      })
      if (response.access_token) {
        dispatch(loginRegisterUser(response))
        history.push('/app')
      } else {
        console.log(response);
      }
  }

    const handleRegister = (e) => {
      history.push('/register')
    }

    const handleGoogleLogin = async () => {
      try {
        const googleURL = await quickey.provider.getURlLogin({
            provider: 'googleLogin'
        })
        window.location.href = googleURL        
      } catch (error) {
        console.log(error);
      }
    }
    
    useEffect(() => {
      window.fbAsyncInit = function() {
        window.FB.init({
            appId      : appId,
            cookie     : false,
            xfbml      : true,
            version    : 'v10.0',
        });        
      };

      (function(d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/de_DE/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));
    }, [appId])

    const handleFacebookLogin = async () => {
      try {
        const app = await quickey.app.getMetaData()
        const fb = await quickey.provider.getData({
          appId: app.appId,
          type: 'socialLogin',
          provider: 'facebookLogin'
        })
        let fbLoginPayload;
        window.FB.getLoginStatus(function(response) {
            if (!response.authResponse?.accessToken) {
              window.FB.login(function(res) {
                if (res.status === 'connected') {
                  window.FB.api('/me?fields=id,name,email', function(data) {
                    fbLoginPayload = {fbID: data.id, fbEmail:data.email, fbToken:fb.dataToken, role:'customer'}
                  });    
                }
              }, {scope: 'email', return_scopes: true});
            } else if (response.status === 'connected' && response.authResponse.accessToken) {
              window.FB.api('/me?fields=id,name,email', function(data) {
                fbLoginPayload = {fbID: data.id, fbEmail:data.email, fbToken:fb.dataToken, role:'customer'}
              }, {scope: 'email', return_scopes: true});
            }
          });
          const facebookURL = await quickey.provider.getURlLogin(fbLoginPayload)
          window.location.href = facebookURL          
      } catch (error) {
          console.log(error);    
      }
    }
   
    const handleLinkedInLogin = async () => {
      try {
        const linkedInURL = await quickey.provider.getURlLogin({
          provider: 'linkedInLogin'
        })
        window.location.href = linkedInURL
      } catch (error) {
        console.log(error)
      }
    }


    const BlackCheckbox = withStyles({
      root: {
        color: '#2b2b2b',
        padding: "3px 3px 3px 10px",
        '&$checked': {
          color: '#2b2b2b',
          padding: "3px 3px 3px 10px",
        },
      },
      checked: {},
    })((props) => <Checkbox color="default" {...props} />);

         
    return (
    <>
      <Container className={classes.containerNavbar} maxWidth="xl" >
        <Navigation locale={setLocale}/>
      </Container>
      <Container className="loginPage py-5 mb-5" component="main" maxWidth="md">
      <Grid className={classes.containerTop} container direction="row" alignItems="center">
        <Grid xs={12} md={5}>
          <div className={classes.paper}>
            <p className="mb-1 bold font-size-20">
              {t('login.welcome')}
            </p>
            
            <form className={classes.form} noValidate onSubmit={handleEmailSubmit}>
              <TextField
                variant="outlined"
                margin="dense"
                size="small"
                required
                fullWidth
                id="email"
                placeholder={t('login.username')}
                name="email"
                autoComplete="email"
                autoFocus
                onChange={handleChange}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PersonOutlineOutlinedIcon />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                variant="outlined"
                margin="dense"
                size="small"
                placeholder={t('login.password')}
                required
                fullWidth
                type={values.showPassword ? 'text' : 'password'}
                value={values.password}
                name="password"
                autoComplete="current-password"
                onChange={handleChangePassword('password')}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockOutlinedIcon />
                    </InputAdornment>
                  ),endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                      >
                        {values.showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <div className="d-flex align-items-center" style={{justifyContent : "space-between" }}>
                <FormControlLabel
                  className="font-size-14"
                  control={<BlackCheckbox checked={state.checkedG} onChange={handleChangeCheck} name="checkedG" />}
                  label={t('login.check')}
                  size="small"
                />
                <Link href="#" className="font-size-14 text-darkgrey reguler">{t('login.forgotPass')}</Link>
              </div>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                className={classes.submit}
              >
                {t('login.login')}
              </Button>
            </form>
            <Grid container>
              <Grid item xs={4} md={4}>  
                <hr/>
              </Grid>
              <Grid className="d-flex align-items-center justify-content-center" item xs={4} md={4}>  
                <p className="font-size-12 reguler mb-0 text-center">{t('login.loginOtp')}</p>
              </Grid>
              <Grid item xs={4} md={4}>  
                <hr/>
              </Grid>
            </Grid>
            <form className={classes.form} noValidate onSubmit={handleOtpSubmit}>
              <TextField
                variant="outlined"
                margin="dense"
                size="small"
                required
                fullWidth
                id="phone"
                placeholder={t('login.noHp')}
                name="phone"
                autoComplete="tel"
                autoFocus
                onChange={handleChange}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PersonOutlineOutlinedIcon />
                    </InputAdornment>
                  ),
                }}
              />
              <div style={{display: 'flex', justifyContent: 'space-evenly'}}>
              {/* <Button
                variant="contained"
                className={classes.submit}
                onClick={() => handleClickOpen('smsOTP')}
                style={{marginRight:'5px'}}
              >
                {t('login.kodeOtp')}
              </Button> */}
              <Button
                variant="contained"
                fullWidth
                className={classes.submit}
                onClick={() => handleClickOpen('waOTP')}
              >
                {t('login.kodeWaOtp')}
              </Button>              
              <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <h4 id="alert-dialog-title" className="text-center bold pt-4">{t('login.verifOtpTitle')}</h4>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description" className={classes.dialogContentText}>
                    {t('login.verifOtpTxt')} &thinsp;
                    <span className={classes.phoneNumber}>{input.phone}</span>
                  </DialogContentText>
                  <div style={{position: "relative"}}>
                  <TextField
                    id="standard-basic"
                    label={t('login.verifCode')}
                    fullWidth
                    // id="otpCode"
                    name="otpCode"
                    onChange={handleChange}
                  />
                  <Button className={classes.btnResend} onClick={handleOtpSubmit} >{t('login.resendOtp')}</Button>
                  </div>
                  <p className="d-flex font-size-12 text-grey reguler mt-1 mb-0" style={{justifyContent: "flex-end"}}>
                    <span>{t('login.pleaseWait')} 00:<span>15</span></span>
                  </p>
                </DialogContent>
                <DialogActions>
                  <Button
                    variant="contained"
                    className={classes.submitPopup}
                    onClick={handleOtpConfirmation}
                  >
                    {t('login.verif')}
                  </Button>
                </DialogActions>
                <div className="d-flex align-items-center" style={{ justifyContent : "space-between", padding: "0 25px 25px" }}>
                  <Link href="#" className="font-size-12 text-grey reguler">{t('login.changePhoneNumber')}</Link>
                  <Link href="#" className="font-size-12 text-grey reguler">{t('login.needHelp')}</Link>
                </div>
                <Button className={classes.btnClosePopup} autoFocus onClick={handleClose} color="primary">
                  <FaTimes/>
                </Button>
                </Dialog>
              </div>
            </form>
            <Grid container className="mb-3">
              <Grid item xs={3} md={3}>  
                <hr/>
              </Grid>
              <Grid className="d-flex align-items-center justify-content-center" item xs={6} md={6}>  
                <p className="font-size-12 reguler mb-0 text-center">{t('login.loginSocialMedia')}</p>
              </Grid>
              <Grid item xs={3} md={3}>  
                <hr/>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={4} md={4}>  
                <button className="btn-google w-100" onClick={() => handleGoogleLogin()}>
                  <span><img src="/google-logo.png" alt="google-logo" width="18px"/></span>
                </button>
              </Grid>
              <Grid item xs={4} md={4}> 
                <button className="btn-linkedin w-100" onClick={() => handleLinkedInLogin()}>
                <span><img src="/linkedin-logo.png" alt="linkedin-logo" width="18px"/></span>
                </button>
              </Grid>
              <Grid item xs={4} md={4}> 
                <button className="btn-fb w-100" onClick={() => handleFacebookLogin()}>
                  <span><img src="/facebook-logo.png" alt="facebook-logo" width="18px"/></span>
                </button>
              </Grid>
            </Grid>
            <Grid container alignItems="center">
                <Grid item xs={12} md={12} className="text-center mt-2">
                  <span className="font-size-14">{t('login.signUpTxt')}&thinsp;</span>
                  <Link href="#" className="bold font-size-14" onClick={handleRegister}>
                    {t('login.signUp')}
                  </Link>
                </Grid>
            </Grid>
          </div>
        </Grid>
        <Grid xs={12} md={2}>
          <div className="m-auto text-center w-100">
            <img className={classes.divider} src="/divider-login.png" alt="divider-login" width="10%"/>
          </div>
        </Grid>
        <Grid xs={12} md={5}>
          <div className="d-flex align-items-center" style={{ flexDirection : "column" }}>
            <img className={classes.imageLogin} src="/login-image.png" alt="login-image" width="100%"/>
            <p className={classes.txtLogin}>
              {t('content.tagline')}
            </p>
          </div>
        </Grid>
      </Grid>
      </Container>
      <div>
        <ContactForm/>
      </div>
    </>
    )
}

export default withTranslation()(Login)
